import { useEffect, useState, useCallback } from "react";
import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/**
 * AI Drafts Bell — shows a purple sparkle icon with a count badge for pending AI drafts.
 * Clicking navigates to /ai-lab (drafts inbox is at the top of that page).
 */
export default function AIDraftsBell() {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/ai-copilot/drafts");
      const pending = (res.data?.drafts || []).filter(d => d.status !== "promoted").length;
      setCount(pending);
    } catch (e) {
      // Silent — user may not have access
    }
  }, [api]);

  useEffect(() => {
    load();
    const id = setInterval(load, 60000); // refresh every 60s
    return () => clearInterval(id);
  }, [load]);

  return (
    <button
      type="button"
      onClick={() => navigate("/ai-lab")}
      className="relative inline-flex items-center justify-center w-9 h-9 rounded-full hover:bg-purple-50 transition-colors"
      title={count > 0 ? `${count} AI draft(s) awaiting review` : "AI Lab — no pending drafts"}
      data-testid="ai-drafts-bell"
    >
      <Sparkles className="w-5 h-5 text-purple-600" />
      {count > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 rounded-full bg-purple-600 text-white text-[10px] font-bold ring-2 ring-white"
          data-testid="ai-drafts-count"
        >
          {count > 9 ? "9+" : count}
        </span>
      )}
    </button>
  );
}
